import React from "react";
import * as style from "./Modal.styles";
import { ModalContent } from "../constant/Modal";

/**
 * 모달 배경
 * @param children 모달 내용
 * @param containerWidth 모달 너비
 * @param containerHeight 모달 높이
 * @param border 모달 테두리 여부
 */

export interface RootProps {
  children: React.ReactNode;
  containerWidth?: string;
  containerHeight?: string;
  border?: boolean;
  className?: string;
}

const BackGround = ({ children, containerWidth, containerHeight, border, className }: RootProps): JSX.Element => {
  return (
    <style.ModalBackground>
      <style.ModalContainer
        containerWidth={containerWidth}
        containerHeight={containerHeight}
        border={border}
        className={className}
      >
        {children}
      </style.ModalContainer>
    </style.ModalBackground>
  );
};

const AlertBackground = ({ children, containerWidth, className }: RootProps): JSX.Element => {
  return (
    <style.ModalBackground>
      <style.AlertModalContainer>
        {children}
      </style.AlertModalContainer>
    </style.ModalBackground>
  );
};

const AlertHeader = ({ children, className }: RootProps): JSX.Element => {
  return (
    <style.AlertHeader>
      {children}
    </style.AlertHeader>
  );
};

const AlertContent = ({ children, className }: RootProps): JSX.Element => {
  return (
    <style.AlertContent>
      {children}
    </style.AlertContent>
  );
};

const AlertBottom = ({ children, className }: RootProps): JSX.Element => {
  return (
    <style.AlertBottom>
      {children}
    </style.AlertBottom>
  );
};

/**
 * 모달 헤더
 * @param title 모달 타이틀
 * @param onClose 모달 닫기 함수
 */
interface HeaderProps {
  title: string;
  onClose: () => void;
}

const Header: React.FC<HeaderProps> = ({ title, onClose }) => {
  return (
    <style.Top>
      <style.TopTitle>{title}</style.TopTitle>
      <style.CloseButton onClick={onClose} />
    </style.Top>
  );
};

/**
 * 모달 내용
 * @param children 모달 내용
 * @param className 모달 내용 클래스
 */
interface ContentProps {
  children: React.ReactNode;
  className?: string;
}

const Content: React.FC<ContentProps> = ({ children, className }) => {
  return <style.Content className={className}>{children}</style.Content>;
};

/**
 * 모달 내용 (스크롤 컨테이너)
 * @param scrollContainerRef 스크롤 컨테이너 참조
 * @param onUpClick 위로 이동 함수
 * @param onDownClick 아래로 이동 함수
 * @param children 모달 내용
 */
interface ContentByScrollProps {
  scrollContainerRef: React.RefObject<HTMLDivElement>;
  onUpClick: () => void;
  onDownClick: () => void;
  children: React.ReactNode;
}

const ContentByScroll: React.FC<ContentByScrollProps> = ({ scrollContainerRef, onUpClick, onDownClick, children }) => {
  return (
    <style.ContentContainer>
      <style.ScrollArea ref={scrollContainerRef}>{children}</style.ScrollArea>

      <style.ScrollButtonWrap>
        <style.UpButton onClick={onUpClick}>
          <style.IconUp />
        </style.UpButton>
        <style.ScrollButton onClick={onDownClick}>
          <style.IconDown />
        </style.ScrollButton>
      </style.ScrollButtonWrap>
    </style.ContentContainer>
  );
};

interface BottomProps {
  children: React.ReactNode;
  className?: string;
}

const Bottom: React.FC<BottomProps> = ({ children, className }) => {
  return (
    <div>
      <style.ButtonWrap className={className}>{children}</style.ButtonWrap>
    </div>
  );
};

const Divider = ({ className }: { className?: string }) => {
  return <style.Divider className={className} />;
};

// ===========공통 안내 팝업 ================
interface CommonHeaderProps {
  title: string;
}

const CommonHeader: React.FC<CommonHeaderProps> = ({ title }) => {
  return (
    <style.CommonTop>
      <style.CommonTopTitle>{title}</style.CommonTopTitle>
    </style.CommonTop>
  );
};

interface CommonContentProps {
  text: string;
  text2?: string;
  className?: string;
}

const CommonContent: React.FC<CommonContentProps> = ({ text, text2, className }) => {
  return (
    <style.CommonContent className={className}>
      <style.CommonContentText>{text}</style.CommonContentText>
      {text2 && <style.CommonContentText>{text2}</style.CommonContentText>}
    </style.CommonContent>
  );
};
const CommonBottom: React.FC = ({ children }) => {
  return <style.CommonBottom>{children}</style.CommonBottom>;
};

export const Modal = {
  BackGround,
  AlertBackground,
  AlertHeader,
  AlertContent,
  AlertBottom,
  Header,
  Content,
  ContentByScroll,
  Bottom,
  Divider,

  CommonHeader,
  CommonContent,
  CommonBottom,
};
